// Featured Tutorial Video Card Component
// Professional video card for the featured section on the root learn page
// Displays title, video preview, description, and likes count

import React, { useState } from 'react';
import './FeaturedTutorialVideoCard.css';

export function FeaturedTutorialVideoCard({
  video,
  onVideoClick,
  isAdmin = false,
  onDelete
}) {
  const [imageError, setImageError] = useState(false);

  // Generate thumbnail URL (reuse logic from existing components)
  const thumbnailUrl = video.thumbnailUrl && video.thumbnailUrl.trim() !== ""
    ? video.thumbnailUrl
    : null; // Could add fallback logic here if needed

  return (
    <div className="featured-tutorial-video-item">
      {/* Title at top */}
      <h3 className="featured-video-title">{video.name}</h3>

      {/* Video section - 2x1 panel style - only this is clickable */}
      <div
        className="featured-video-panel"
        onClick={onVideoClick}
      >
        <div className="featured-video-thumbnail">
          {thumbnailUrl && !imageError ? (
            <img
              src={thumbnailUrl}
              alt={video.name}
              onError={() => setImageError(true)}
            />
          ) : (
            <div className="video-thumbnail-placeholder">
              <i className="fa-solid fa-video"></i>
              <span>Video</span>
            </div>
          )}

          {/* Date overlay - bottom left */}
          {video.date && (
            <div className="featured-video-date">
              <i className="fa-solid fa-calendar"></i> {new Date(video.date).toLocaleDateString()}
            </div>
          )}

          {/* Duration overlay - bottom right */}
          {video.duration && (
            <div className="featured-video-duration">
              {video.duration}
            </div>
          )}

          {/* Play overlay */}
          <div className="featured-video-overlay">
            <i className="fa-solid fa-play"></i>
          </div>
        </div>
      </div>

      {/* Footer with description, tags, and likes */}
      <div className="featured-video-footer">
        <p className="featured-video-description">
          {video.shortDescription || video.description}
        </p>

        {/* Tags and likes in same row */}
        <div className="featured-video-tags-row">
          {/* Tags */}
          {video.tags && video.tags.length > 0 && (
            <div className="featured-video-tags">
              {video.tags.slice(0, 3).map((tag, index) => (
                <span key={index} className="featured-video-tag">{tag}</span>
              ))}
              {video.tags.length > 3 && (
                <span className="featured-video-more-tags">+{video.tags.length - 3}</span>
              )}
            </div>
          )}

          <div className="featured-video-likes">
            <i className="fa-solid fa-thumbs-up"></i>
            <span>{video.likes || 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
}